<template>
  <div :class="$style.page">
    <Title title="在线充值" mode="margin">
      <template v-slot:actions>
        <span :class="$style.btn_back" @click="goBack">返回</span>
      </template>
    </Title>

    <div :class="$style.balance">
      账户可用金额：
      <span :class="$style.balance_number">{{
        amountInfo.restAmount ? amountInfo.restAmount : "0"
      }}</span>
      元
    </div>

<!--    <Item title="充值金额">
      <el-input v-model="amount" @input="onAmountChange"></el-input>
      <span>元，充值最小金额1元</span>
    </Item>

    <Item title="充值方式">
      <div
        :class="[$style.pay, payType === 0 ? $style.pay_active : '']"
        @click="selectPayType(0)"
      >
        <img :class="$style.pay_img" src="@assets/image/weixin.png" alt="" />
        <span>微信</span>
      </div>
    </Item>

    <Item title=" ">
      <Button type="primary" :loading="loading" @click="confirmRecharge">
        确认充值
      </Button>
    </Item>-->

    <Divider :class="$style.divider" />

    <Title title="银行汇款（对公）" />

    <div :class="$style.bank">
      <div :class="$style.bank_img">
        <img
          :class="$style.img"
          src="@assets/image/agricultural_bank.png"
          alt=""
        />
      </div>

      <div :class="$style.bank_content">
        <p>公司名称：河北识道网络科技有限公司</p>
        <p>银行账号： 311904811410000</p>
        <p>开户银行：招商银行石家庄和平东路支行</p>
        <p>
          汇款成功后请将汇款凭证及充值ID发送至official@nsdt.com，等待客服审核处理。
        </p>
      </div>
    </div>

    <PayDialog
      :type="payType"
      :payUrl="payUrl"
      :visible="payVisible"
      @close="setPayVisible(false)"
    />
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { WEBSOCKET_URL } from "@utils/config";
import { createRecharge } from "@server";

import PayDialog from "@components/PayDialog.vue";

export default {
  name: "Recharge",
  components: { PayDialog },
  data() {
    return {
      loading: false,

      amount: "", // 充值金额
      payType: 0, // 支付方式 0 - 微信支付 1 - 支付宝支付
      payUrl: "", // 微信和支付宝的支付链接
      orderNo: "", // 确认充值后的订单号

      payVisible: false, // 显示支付弹框
      wsInst: null, // webSocket 实例
    };
  },
  computed: {
    ...mapState("user", ["amountInfo"]),
  },
  methods: {
    ...mapActions("user", ["getAmountInfoAction"]),

    goBack() {
      this.$router.back();
    },

    onAmountChange(value) {
      /*const val = value.match(/([1-9]\d*)(\.\d{0,2})?/) || [""];
      this.amount = val[0];*/
    },
    selectPayType(type) {
      this.payType = type;
    },
    setPayVisible(v) {
      this.payVisible = v;
    },

    async confirmRecharge() {
      if (this.amount === "") {
        this.$message({ message: "请输入充值金额!", type: "warning" });
        return;
      }

      this.loading = true;
      const params = {
        amount: this.amount,
        source: 0,
        type: this.payType,
      };
      const res = await createRecharge(params);
      const { code, data } = res;

      if (code === 200) {
        this.payUrl = data.url;
        this.orderNo = data.orderNo;
        this.setPayVisible(true);
        this.openSocket();
      }
      this.loading = false;
    },

    sendMessage(txt) {
      this.wsInst.send(txt); // webSocket发送消息
    },

    resetConnect() {
      this.connectCount = this.connectCount || 0;

      if (this.wsInterval) return;

      this.wsResetInterval = setInterval(() => {
        this.connectCount += 1;
        if (this.connectCount <= 5) {
          this.openSocket();
          this.wsResetInterval && clearInterval(this.wsResetInterval);
        }
      }, 1000);
    },

    // 开启webSocket
    openSocket() {
      this.msgTotal = 0; // 消息数
      const wsUrl = `${WEBSOCKET_URL}hbsdweb/webSocket/pay/${
        this.orderNo
      }/${this.$token.get("accessToken")}`;

      this.wsInst = new WebSocket(wsUrl);

      // 接收消息事件
      this.wsInst.onmessage = (e) => {
        if (e.data === "open:suc") {
          this.sendMessage("start");
          this.heartInterval = setInterval(() => {
            if (this.msgTotal === 10) {
              this.sendMessage("heart");
              this.msgTotal = 0;
            }
            this.msgTotal += 1;
          }, 1000);
        }

        if (e.data.indexOf("msg:") !== -1) {
          this.msgTotal = 0;
          let message = e.data.split("msg:")[1];
          let info = JSON.parse(message);

          if (info?.result === "true") {
            // 充值成功
            this.$message({ message: "充值成功", type: "success" });
            this.amount = "";
            this.setPayVisible(false);
            this.getAmountInfoAction();
            this.endSocket();
          }
        }

        if (e.data.indexOf("rec:stop") !== -1) {
          this.wsInst.close();
        }
      };

      // 连接失败事件
      this.wsInst.onerror = () => {
        this.resetConnect();
      };
    },

    // 销毁 webSocket
    endSocket() {
      this.wsInst && this.sendMessage("stop");
      this.heartInterval && clearInterval(this.heartInterval);
      this.wsResetInterval && clearInterval(this.wsResetInterval);
    },
  },
  beforeDestroy() {
    this.endSocket();
  },
};
</script>

<style lang="scss" module scoped>
.page {
  padding: rem(50);
  font-size: rem(14);
  color: #333;
  background: $white;
  box-shadow: $box-shadow;

  :global {
    ::v-deep.gl-item {
      margin-bottom: rem(40);
    }

    .el-input {
      width: 160px;
      margin-right: rem(20);
    }
  }

  .btn_back {
    padding: 5px;
    margin-right: rem(50);
    cursor: pointer;
    &:hover {
      color: $theme-color;
    }
  }

  .balance {
    margin-bottom: rem(40);

    .balance_number {
      color: $theme-color;
      font-weight: bold;
    }
  }

  .pay {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: rem(140);
    height: rem(80);
    padding: 0 20px;
    margin-right: rem(40);
    font-size: nax(rem(18), 16px);
    font-weight: bold;
    color: #333;
    border: $border-1;
    cursor: pointer;

    .pay_img {
      width: rem(45);
      object-fit: cover;
    }

    &:hover,
    &.pay_active {
      border-color: $theme-color;
      color: $theme-color;
    }
  }

  .divider {
    margin: rem(50) 0;
  }

  .bank {
    display: flex;
    align-items: flex-start;
    padding-bottom: rem(40);

    .bank_img {
      width: rem(300);
      height: rem(140);
      border: $border-1;
      margin-right: rem(40);
      @include flex();

      .img {
        width: rem(240);
        object-fit: cover;
      }
    }

    .bank_content {
      line-height: 40px;
      margin-top: -12px;

      p:last-child {
        color: $theme-color;
      }
    }
  }
}
</style>
